// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';

// assets
import useAuth from 'hooks/useAuth';
import UnAuthAppBar from './AppBar/AppBar';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const TopRightMenuButton = () => {
    const theme = useTheme();

    const { user } = useAuth();

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    },
                    color: 'red'
                }}
                data-test-id="layout/MainLayout/TopRightMenuButton/index"
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
            </Box>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile */}
            {user ? <ProfileSection /> : <UnAuthAppBar />}
        </>
    );
};

export default TopRightMenuButton;
